import { AxiosInstance } from "axios"
import { CompaniesOrderItem } from "../../../../company/reports/accounting/pos/posTypes"
import { DateType } from "../../../../../shared/components/filters/selectDateTypeFilter/SelectDateTypeFilter"

export enum SupplierPOSQuery {
    POS_ORDERS_FOR_SUPPLIER = "pos-orders-for-supplier",
}

export type SupplierOrdersParams = Readonly<{
    supplierId: number
    orderId?: string
    startDate?: string
    endDate?: string
    merchantId?: string
    merchantIds?: string
    customerId?: string
    email?: string
    paymentMethods?: string
    creditCardLast4?: string
    shopIds?: string
    dateType: DateType
    orderType?: string
    channel?: string
}>
export type SupplierOrdersResponse = Readonly<{
    orders: CompaniesOrderItem[]
}>

export async function fetchSupplierPosOrders(
    params: SupplierOrdersParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<SupplierOrdersResponse> {
    const { supplierId, ...rest } = params
    const url = `/suppliers/${supplierId}/accounting/pos/orders`
    const { data } = await axios.get(url, {
        params: rest,
        signal,
    })

    return data
}
